import * as THREE from 'three';
import {
    SnapMode,
    SnapState,
} from 'components/customer/RoomPlanner/helpers/snapping/types';

/**
 * Takes a product out of snap mode. Its bounds stay, as they always have, so
 * a later snap overwrites them rather than starting from nothing.
 * @param {THREE.Object3D} cabinet The dragged product.
 */
export const clearSnapState = (cabinet: THREE.Object3D) => {
    cabinet.userData.isSnapMode = false;
    cabinet.userData.wasSnapped = false;
};

// What each mode writes to the product. The only place a snap mode becomes
// userData.
const APPLY_MODE: Record<SnapMode, (cabinet: THREE.Object3D) => void> = {
    attached: (cabinet) => {
        cabinet.userData.isSnapMode = true;
        cabinet.userData.wasSnapped = true;
    },
    detached: clearSnapState,
    suspended: (cabinet) => {
        cabinet.userData.isSnapMode = false;
    },
};

/**
 * Puts the snap state a drag decided on the dragged product. The state lives
 * on the product in memory: the ghost panel shown on detach is a clone, so it
 * carries the same state.
 * @param {THREE.Object3D} cabinet The dragged product.
 * @param {SnapState} [state] The drag's snap state; none leaves the product
 * as it is.
 */
export const applySnapState = (cabinet: THREE.Object3D, state?: SnapState) => {
    if (!state) return;

    if (state.snappedSide !== undefined) {
        cabinet.userData.snappedSide = state.snappedSide;
    }
    if (state.bounds !== undefined) cabinet.userData.bounds = state.bounds;
    if (state.mode !== undefined) APPLY_MODE[state.mode](cabinet);
};
